import classNames from "classnames";
import { AnimatePresence, motion } from "motion/react";
import { Flex } from "./Flex";
import Icon from "./Icon";

import "./SelectionCard.css";

export function SelectionCard(props: {
    selected: boolean;
    onSelect: () => void;
    children: React.ReactNode;
}) {
    const { selected, onSelect, children } = props;

    return (
        <Flex.Row
            className={classNames(
                "web-lib__selection-card",
                selected && "web-lib__selection-card--selected",
            )}
            role="button"
            onClick={onSelect}
        >
            <div className="web-lib__selection-card__icons">
                <motion.div
                    className="web-lib__selection-card__icons-unselected"
                    variants={ICON_ANIMATIONS.INITIAL}
                    initial="visible"
                    animate={selected ? "hidden" : "visible"}
                    transition={ICON_ANIMATIONS.INITIAL.transition}
                >
                    <Icon.Add.Medium />
                </motion.div>

                <AnimatePresence>
                    {selected && (
                        <motion.div
                            className="web-lib__selection-card__icons-selected"
                            variants={ICON_ANIMATIONS.SELECTED}
                            initial="initial"
                            animate="animate"
                            exit="exit"
                            transition={ICON_ANIMATIONS.SELECTED.transition}
                        >
                            <Icon.ThumbUp.Medium />
                        </motion.div>
                    )}
                </AnimatePresence>
            </div>

            <div className="web-lib__selection-card__content">{children}</div>
        </Flex.Row>
    );
}

const ICON_ANIMATIONS = {
    INITIAL: {
        hidden: { opacity: 0, rotateZ: 15 },
        visible: { opacity: 1, rotateZ: 0 },
        transition: {
            duration: 0.25,
            ease: "easeInOut",
        },
    },
    SELECTED: {
        initial: {
            opacity: 0,
            rotateZ: -25,
            scale: 0.95,
            translateY: "-50%",
            translateX: "-50%",
        },
        animate: {
            opacity: 1,
            rotateZ: 0,
            scale: 1,
            translateY: "-50%",
            translateX: "-50%",
        },
        exit: {
            opacity: 0,
            rotateZ: -25,
            scale: 0.95,
            translateY: "-50%",
            translateX: "-50%",
        },
        transition: {
            duration: 0.15,
            ease: "easeInOut",
        },
    },
} as const;
